import { IconButton } from "@mui/joy";
import CssBaseline from "@mui/joy/CssBaseline";
import { CssVarsProvider, extendTheme } from "@mui/joy/styles";
import * as React from "react";
import {
  RouterProvider,
  createBrowserRouter,
  useNavigate,
  useRouteError,
} from "react-router";

import Activity from "./pages/activity";
import Allcoins from "./pages/allcoins";
import AuthIndex, { siteName } from "./pages/Authentication";
import Login from "./pages/Authentication/login";
import ResetPassword from "./pages/Authentication/resetpassword";
import SignUp from "./pages/Authentication/signup";
import Buy from "./pages/buy";
import CoinDetail from "./pages/coindetail";
import Confirm from "./pages/confirm";
import ConnectWallet from "./pages/connectwallet/phrase";
import { DashboardIndex } from "./pages/dashboard";
import HomeIndex from "./pages/homeindex";
import Notification from "./pages/notification";
import Profile from "./pages/profile";
import ReceiveSingle from "./pages/receivesingle";
import Receive from "./pages/recieve";
import Send from "./pages/send";
import Settings from "./pages/settings";
import Success from "./pages/success";
import Swap from "./pages/swap";
import SwapSuccess from "./pages/success";
import InstallPwa from "./pages/installios";
import TransactinDetails from "./pages/transactindetail";
import { UploadId } from "./pages/upload";
import ConnectOptions from "./pages/connectwallet/connectoptions";

const url = `${window.location.protocol}//${window.location.host}`;
export const encodedurl = btoa(url);
export const encodesite = btoa(siteName);

// ✅ Force dark theme only
const customTheme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          50: "#fafaf9",
          100: "#f5f5f4",
          200: "#e7e5e4",
          300: "#d6d3d1",
          400: "#a8a29e",
          500: "#262626",
          600: "#57534e",
          700: "#44403c",
          800: "#292524",
          900: "#1c1917",
        },
      },
    },
  },
  defaultColorScheme: "light",
});

function ErrorBoundary() {
  const navigate = useNavigate();
  let error = useRouteError();
  console.error(error);

  React.useEffect(() => {
    navigate("../");
  }, [navigate]);

  return null;
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <DashboardIndex />,
    errorElement: <ErrorBoundary />,
    children: [
      { path: "/", element: <HomeIndex /> },
      { path: "/swap", element: <Swap /> },
      { path: "/swap/success", element: <SwapSuccess /> },
      { path: "/activity", element: <Activity /> },
      { path: "/allcoin", element: <Allcoins /> },
      { path: "/notifications", element: <Notification /> },
      { path: "/coin", element: <CoinDetail /> },
      { path: "/receive", element: <Receive /> },
      { path: "/receive/coin", element: <ReceiveSingle /> },
      { path: "/buy", element: <Buy /> },
      { path: "/send", element: <Send /> },
      { path: "/confirm", element: <Confirm /> },
      { path: "/settings", element: <Settings /> },
      { path: "/connectwallet", element: <ConnectOptions /> },
      { path: "/profile", element: <Profile /> },
      {
        path: "/upload/kyc/:encodedimageurl/:userid",
        element: <UploadId />,
      },
      {
        path: "/detail",
        element: <TransactinDetails />,
        errorElement: <ErrorBoundary />,
      },
      {
        path: "/success",
        element: <Success />,
        errorElement: <ErrorBoundary />,
      },
    ],
  },
  {
    path: "/connect",
    element: <ConnectWallet />,
  },
  {
    path: "/auth",
    element: <AuthIndex />,
    children: [
      { path: "/auth", element: <Login /> },
      { path: "/auth/reset", element: <ResetPassword /> },
      { path: "/auth/register", element: <SignUp /> },
    ],
  },
]);

function App() {
  return (
    <CssVarsProvider
      theme={customTheme}
      defaultMode="light"
      modeStorageKey={null} // 🔥 prevents saving light mode anywhere
      disableTransitionOnChange
    >
      <CssBaseline />
      <InstallPwa />
      <RouterProvider router={router} />
    </CssVarsProvider>
  );
}

export default App;
